// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1v_T7","m-signature-pad--body":"styles__m-signature-pad--body___3Ciy6","m-signature-pad--footer":"styles__m-signature-pad--footer___2jogj","description":"styles__description___MCb1h","button":"styles__button___wwFUQ","clear":"styles__clear___Fe_Jp","save":"styles__save___744CH","m-signature-pad":"styles__m-signature-pad___2gPQS","github":"styles__github___1nxXP","PurchaseOrder":"styles__PurchaseOrder___2Ipbb"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/PurchaseOrders/styles.scss
// module id = vMT/
// module chunks = client